/* eslint-disable camelcase */
export enum OrderStage {
  UNTREATED = 2, // 未处理
  UNDERWAY = 5, // 进行中
  COMPLETED = 8, // 已完成
  SERVICE_ALL = -1, // 传空
  NULL = '', // 所有订单
  SERVICE_UNDERWAY = 2, // 进行中
  SERVICE_APPEAR = 3, // 上报
  SERVICE_HANDUP = 4, // 挂单
  SERVICE_TRANSFER = 5, // 转出单
  SERVICE_FINISH = 6, // 已完成
  SERVICE_CLOSE = 7, // 已关闭

}

export declare class IOrderParams {
  user_id: number
  company_id: string
  page: number
  size?: number
  complaint_state: OrderStage
  is_need_task?: number
}
